<div class="flex">
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'GUESTXP.GUESTXP' | transloco">
    <sbnb-gx-subnav></sbnb-gx-subnav>
  </sbnb-subnav>

  <main class="flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <mat-spinner *ngIf="loading" [diameter]="32"></mat-spinner>

    <div *ngIf="!loading && product">
      <!-- Heading -->
      <div class="flex items-center gap-4">
        <sbnb-back-button [iconOnly]="true" [routerLink]="['/gx/upsells']"></sbnb-back-button>

        <!-- Add the toggle here -->
        <mat-slide-toggle [checked]="product.active" (change)="toggleProductStatus($event)"></mat-slide-toggle>

        <!-- Editable private name -->
        <h2 class="input__editable mb-0 flex-1">
          <span
            #nameSpan
            style="padding-left: 0; padding-right: 8px; visibility: hidden; position: absolute; left: -9999px">
            {{ product.private_name }}
          </span>

          <input
            class="input__borderless"
            type="text"
            [style.width.px]="nameSpan.getBoundingClientRect().width"
            [(ngModel)]="product.private_name"
            (change)="updateProduct()" />
        </h2>

        <div *ngIf="saveStatus && saveStatus !== 0" class="save-status">
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
        </div>
      </div>

      <sbnb-cs-debug-item label="Product ID" [value]="product.id" linkLabel="Details"></sbnb-cs-debug-item>

      <div class="rule__section-container">
        <div class="detail-subitem">
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="6px" class="detail-subheader">
            <h3 class="!mb-0" fxFlex>Guest-facing product name</h3>

            <sbnb-button
              *ngIf="!editingPublicName"
              size="mini"
              label="Edit"
              type="text"
              (click)="editingPublicName = true"></sbnb-button>
          </div>

          <span *ngIf="!editingPublicName" class="night text__small clamp">
            {{ product.public_name || 'Guest-facing name not set' }}
          </span>

          <ng-container *ngIf="editingPublicName">
            <mat-form-field class="fw mt-2 mb-3 nopadding">
              <input
                #publicNameInput
                matInput
                [value]="product.public_name"
                placeholder="Public Name"
                (keyup.enter)="
                  editingPublicName = false; product.public_name = publicNameInput.value; updateProduct()
                " />
            </mat-form-field>

            <div fxLayoutAlign="end center" fxLayoutGap="8px">
              <sbnb-button
                label="Cancel"
                type="secondary"
                size="mini"
                (clicked)="editingPublicName = false"></sbnb-button>
              <sbnb-button
                label="Save"
                size="mini"
                (clicked)="
                  editingPublicName = false; product.public_name = publicNameInput.value; updateProduct()
                "></sbnb-button>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="rule__section-container">
        <!-- Show variations section for early_checkin and late_checkout -->
        <ng-container>
          <div class="flex items-center mb-4" *ngIf="product.variations.length > 1">
            <h3 class="flex-1 !mb-0">Product Variations</h3>
            <!-- <sbnb-button size="mini" label="+ Add new" type="text" (click)="addVariation()"></sbnb-button> -->
          </div>

          <div class="variations-list">
            <div class="flex items-center gap-6 mb-2 text-sm text-night-lighter" data-tour="variations-header">
              <div class="w-8" *ngIf="product.variations.length > 1">Status</div>
              <div class="flex-1" *ngIf="product.type === 'early_checkin' || product.type === 'late_checkout'">
                Time Window
              </div>
              <div class="flex items-center gap-1">
                <span>Price</span>
                <span *ngIf="product.pricing_type == 'per_night'">per night</span>
                <sbnb-icon
                  icon="calendar"
                  class="text-night-lighter"
                  *ngIf="product.pricing_type == 'per_night'"></sbnb-icon>
              </div>
            </div>

            <div
              *ngFor="let variation of product.variations; let i = index"
              class="variation-item mb-1"
              fxLayout
              fxLayoutAlign="start center"
              fxLayoutGap="24px">
              <mat-slide-toggle
                *ngIf="product.variations.length > 1"
                fxFlex="32px"
                [checked]="variation.active"
                (change)="toggleVariationStatus(variation, $event)"></mat-slide-toggle>

              <div fxFlex *ngIf="product.type === 'early_checkin' || product.type === 'late_checkout'">
                {{ variation.metadata.hours }} {{ 'hours' | pluralize: variation.metadata.hours }}
                <ng-container [ngSwitch]="product.type">
                  <ng-container *ngSwitchCase="'early_checkin'">before</ng-container>
                  <ng-container *ngSwitchCase="'late_checkout'">after</ng-container>
                </ng-container>
              </div>

              <mat-form-field fxFlex="120px" class="input__mini nopadding">
                <input
                  matInput
                  #priceInput
                  type="tel"
                  maxlength="6"
                  autocomplete="off"
                  placeholder="0"
                  [ngModel]="variation.price.amount"
                  (change)="updateVariation(variation, priceInput.value)"
                  (keyup.enter)="updateVariation(variation, priceInput.value)" />

                <span matSuffix>{{ variation.price.currency }}</span>
              </mat-form-field>
            </div>
          </div>
        </ng-container>

        <!-- Show simple price field for cleaning product -->
        <ng-container *ngIf="product.type === 'cleaning'">
          <div class="flex items-center mb-4">
            <h3 class="flex-1 !mb-0">Price</h3>
          </div>

          <div class="flex items-center" data-tour="cleaning-price">
            <mat-form-field class="w-32">
              <input
                matInput
                #cleaningPriceInput
                type="tel"
                maxlength="6"
                autocomplete="off"
                placeholder="0"
                [ngModel]="product.variations[0]?.price.amount"
                (change)="updateVariation(product.variations[0], cleaningPriceInput.value)"
                (keyup.enter)="updateVariation(product.variations[0], cleaningPriceInput.value)" />
              <span matSuffix>{{ product.variations[0]?.price.currency }}</span>
            </mat-form-field>
          </div>
        </ng-container>
      </div>

      <div class="rule__section-container"></div>
      <div fxLayout fxLayoutAlign="start center">
        <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="mb-8">
          <img src="/assets/iconography/settings.svg" />
          <span>Settings</span>
          <span class="card__collapsed-helper-text">Fine-tune preferences for this product.</span>
        </h3>
      </div>

      <div class="space-y-6">
        <!-- Can be bought in booking flow -->
        <div
          class="setting__container"
          [class.setting__container-active]="product.prebooking"
          data-tour="product-block-day">
          <div class="flex items-center gap-4">
            <mat-checkbox [(ngModel)]="product.prebooking" (change)="updateProduct()" class="flex-none">
              <strong>Can be purchased while booking</strong>
            </mat-checkbox>
            <span class="card__collapsed-helper-text">
              Allows guests to buy this upsell while making the initial booking, as well as in the guest portal
              afterwards. (Only for Direct bookings.)
            </span>
          </div>
        </div>

        <!-- Block Day Option -->
        <div
          *ngIf="product.type === 'early_checkin' || product.type === 'late_checkout'"
          class="setting__container"
          [class.setting__container-active]="product.blocks_day"
          data-tour="product-block-day">
          <div class="flex items-center gap-4">
            <mat-checkbox [(ngModel)]="product.blocks_day" (change)="updateProduct()" class="flex-none">
              <strong>Block day {{ product.type === 'early_checkin' ? 'before' : '' }}</strong>
            </mat-checkbox>
            <span class="card__collapsed-helper-text">
              Activating this setting will automatically make the
              <strong>{{ product.type === 'early_checkin' ? 'day before check-in' : 'checkout day' }}</strong>
              unavailable for other bookings whenever the upsell is purchased.
            </span>
          </div>
        </div>

        <!-- Buffer Period -->
        <div class="rule__section-container rule__section-collapsed" *ngIf="product.type !== 'custom'">
          <div class="flex items-center">
            <h3 class="flex items-center gap-3 !m-0 pr-10">
              <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
              <span>Timing</span>
            </h3>

            <div class="flex items-center gap-4" data-tour="product-buffer-period">
              <span class="text-sm font-medium text-night">Purchase not allowed if less than</span>

              <sbnb-rule-timing
                *ngIf="timingsMeta && product"
                [meta]="timingsMeta"
                [ruleset]="product"
                (triggerSave)="timingUpdated()"></sbnb-rule-timing>

              <span class="text-sm font-medium text-night">
                remaining until
                <ng-container [ngSwitch]="product.type">
                  <ng-container *ngSwitchCase="'early_checkin'">check-in</ng-container>
                  <ng-container *ngSwitchCase="'late_checkout'">checkout</ng-container>
                  <ng-container *ngSwitchCase="'cleaning'">the chosen cleaning day</ng-container>
                </ng-container>
                .
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="rule__section-container">
        <div class="flex items-center mb-4">
          <h3
            class="flex items-center gap-2 flex-1 !mb-0 cursor-pointer"
            (click)="toggleMessagingRules()"
            data-tour="messaging-rules-header">
            <img src="/assets/iconography/nav-rule-manager.svg" alt="rules" />
            <span>Messaging Rules {{ smartUpsellRules?.length ? '(' + smartUpsellRules?.length + ')' : '' }}</span>
            <sbnb-icon
              icon="small-arrow-bottom"
              class="text-smoke-darker ml-1"
              [style.transform]="messagingRulesCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)'"></sbnb-icon>
          </h3>
          <sbnb-button
            size="mini"
            label="+ Add to more rules"
            type="text"
            [routerLink]="['/gx/rules/segments/47dd6325-87dc-48e1-bebd-e68f532410ca']"
            data-tour="add-upsell-rule"></sbnb-button>
        </div>

        <div [hidden]="messagingRulesCollapsed">
          <!-- Add the helper text here -->
          <p *ngIf="smartUpsellRules?.length > 0" class="text-sm text-night-lighter mb-4">
            These messaging rules will automatically promote this upsell to your guests at the right time.
          </p>

          <div class="space-y-3">
            <div *ngIf="!smartUpsellRules?.length" class="text-sm text-night">
              Add the
              <button
                [routerLink]="['/gx/rules/segments/47dd6325-87dc-48e1-bebd-e68f532410ca']"
                class="button__smartcode inline-flex gap-2 mx-2 items-center">
                <span>Smart Upsell</span>
                <img src="/assets/iconography/magic.svg" onload="SVGInject(this)" alt="Use smart code" />
              </button>
              Smart Code to your messaging rules to automatically promote it.
            </div>

            <div
              *ngFor="let rule of smartUpsellRules"
              (click)="openRule(rule.id)"
              class="flex items-center gap-4 p-3 border border-smoke rounded cursor-pointer hover:bg-gray-50"
              data-tour="upsell-rule-item">
              <mat-slide-toggle
                [checked]="rule.active"
                [disabled]="true"
                (click)="$event.stopPropagation()"
                class="cursor-default"></mat-slide-toggle>

              <div class="flex-1">
                <span class="font-medium">{{ rule.name }}</span>
              </div>

              <div class="flex items-center gap-2 text-sm text-smoke-darker">
                <sbnb-icon icon="time" class="shrink-0"></sbnb-icon>
                <span>{{ rule.event_short }}</span>
              </div>

              <div class="flex items-center gap-2">
                <sbnb-icon icon="properties" [size]="20" class="shrink-0 text-smoke-darker"></sbnb-icon>
                <span>{{ rule.all_properties ? 'All' : rule.properties.length }}</span>
              </div>

              <div class="flex items-center gap-2">
                <img src="/assets/iconography/nav-team.svg" alt="hosts" class="w-5 h-5" />
                <span>
                  {{ rule.all_hosts ? 'All' : rule.active_hosts_count ? rule.active_hosts_count : rule.hosts.length }}
                </span>
              </div>

              <div class="flex items-center gap-2">
                <sbnb-icon-homeaway [muted]="!rule.platforms.includes('homeaway')"></sbnb-icon-homeaway>
                <sbnb-icon-airbnb [muted]="!rule.platforms.includes('airbnb')"></sbnb-icon-airbnb>
                <sbnb-icon-booking [muted]="!rule.platforms.includes('booking')"></sbnb-icon-booking>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rule__section-container">
        <h3>Scoping</h3>
        <sbnb-rule-scope [initial]="product" (completed)="handleScopeChange($event)"></sbnb-rule-scope>
      </div>

      <div class="rule__section-container" fxLayout>
        <div fxFlex fxLayout fxLayoutGap="6px" fxLayoutAlign="start center">
          <sbnb-button
            label="Delete"
            icon="trash"
            type="secondary-danger"
            (clicked)="deleteProductPrompt()"></sbnb-button>
        </div>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>

      <!-- <div class="save-button-container mt-4">
        <sbnb-button label="Save" [loading]="saveStatus === 1" (clicked)="updateProduct()"></sbnb-button>
      </div> -->
    </div>
  </main>
</div>
